import React from 'react';

/**
 * Hook para gerenciar filtros do tree view
 * @param {Array} items - Array de itens para filtrar
 */
export const useTreeFilter = (items = []) => {
  const [activeFilter, setActiveFilter] = React.useState(null);

  // Função para aplicar filtro
  const applyFilter = (filter) => {
    setActiveFilter(filter);
  };

  // Função para limpar filtro
  const clearFilter = () => {
    setActiveFilter(null);
  };

  // Itens filtrados baseado no filtro ativo
  const filteredItems = React.useMemo(() => {
    if (!activeFilter) {
      return items;
    }

    return items.filter(item => {
      if (activeFilter.type === 'carrier') {
        // Filtrar por transportadora
        return item.carrier_name === activeFilter.carrierName;
      } else if (activeFilter.type === 'status') {
        // Filtrar por transportadora e status
        return item.carrier_name === activeFilter.carrierName &&
          item.state === activeFilter.statusKey;
      }
      return true;
    });
  }, [items, activeFilter]);

  return {
    activeFilter,
    setActiveFilter: applyFilter,
    clearFilter,
    filteredItems,
    hasFilter: !!activeFilter,
    totalResults: filteredItems.length,
    totalItems: items.length
  };
}; 